import React, { Component } from "react";
import { withRouter } from "react-router";

import {
  FormGroup,
  Row,
  Col,
  Label,
  Input,
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  FormFeedback
} from "reactstrap";
import withReactContent from "sweetalert2-react-content";
import api from "../../utils/axiosApi";
import { Toast } from "../../utils/sweetalert";
import { nameSchema } from "../../utils/validateForm";
import Picker from 'emoji-picker-react';
import Dropzone from "react-dropzone";
import * as  XLSX from 'xlsx';


class FormCities extends Component {
  constructor(props) {
    super(props) 
    this.state = {
      file : {
        name: ''
      },
      jsonExcel : [],
      city : '',
      state : '',
      country : '',
      cityEn : '',
      stateEn : '',
      countryEn : '',
      priority : '',
      priceTypeDefault : '$',
      lat:0,
      lon:0,
      latAirport:0,
      lonAirport:0,
      radius:1500,
      disabled:false,
      emoji:undefined,
      citiesList:[],
      errors : {
        city : false,
        state : false,
        country : false,
        citiesList:false
      }
    }
    this.handleAddToList = this.handleAddToList.bind(this)
    this.handleExcelCities = this.handleExcelCities.bind(this)
    this.handleFile = this.handleFile.bind(this)
  }
  handleSubmit = async (e) =>{
    e.preventDefault()
         try {
          await api.post(`/ciudades/setcitiesList`, {listCities: this.state.citiesList})
          debugger
          //this.props.history.push('/admin/VerAdmins')
          const MySwal = withReactContent(Toast)
            await MySwal.fire({
                title: <p style={{fontSize: '15px'}}>ciudad creado Exitosamente</p>,
                icon: 'success',
                
            })
         } catch (error) {
           //console.log(error)
           const MySwal = withReactContent(Toast)
            await MySwal.fire({
                title: <p style={{fontSize: '15px'}}>algo salio Mal...</p>,
                icon: 'error',
                
            })
         }
    
  }
  
  handleFile = (acceptedFiles) => {
    const noXLSX= acceptedFiles.find((e) => {
      return e.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })
    if(noXLSX) return
    this.setState({files: acceptedFiles[0]})
    debugger
    let hojas = []
    let reader = new FileReader()
    reader.readAsArrayBuffer(acceptedFiles[0])
    reader.onloadend= (e) => {
      var data = new Uint8Array(e.target.result)
      var workbook = XLSX.read(data, {type: 'array'})

      workbook.SheetNames.forEach(function (sheetName) {
        var XL_row_obj = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName])
        hojas.push({
          data: XL_row_obj,
          sheetName
        })
      })
      //console.log(hojas)
      this.setState({
        file: acceptedFiles[0],
        jsonExcel: hojas
      })
    }
  }
  handleExcelCities = async (e) =>{
    e.preventDefault()
    const MySwal = withReactContent(Toast)
    if(this.state.jsonExcel.length ===0 ) {
      await MySwal.fire({
        title: <p style={{fontSize: '15px'}}>Introduzca los archivos</p>,
        icon: 'error',
        
    })
    return
    }
    try {
      this.setState({disabled: true})
      const resp = await api.put(`/ciudades/editcities`, {data: JSON.stringify(this.state.jsonExcel)})
      /*
      const formData = new FormData()
      formData.append('dataJson', JSON.stringify(this.state.jsonExcel))
      formData.append('cityId', this.state.city)
      const resp = await api.post(`/adminsplaces/detectExtraAct`, formData, {     
       headers: { 'content-type': 'multipart/form-data' }
     })
      */
      //console.log(resp)
    await MySwal.fire({
      title: <p style={{fontSize: '15px'}}>Actividad creado Exitosamente</p>,
      icon: 'success',
      
  })
    } catch (error) {
      //console.log(error)
    }
  this.setState({disabled: false})
  }
  handleChange = (e) => {
    debugger
    const value = e.target.value
    this.setState({[e.target.name]: value})
  }
  
  handleChangeLngLat = (e) => {
    debugger
    const fixValue = e.target.value !== '' ? e.target.value.replace(',','.') : '0'
    const value = parseFloat(fixValue)
    this.setState({[e.target.name]: value })

  }
  
  handleLonLat = (lonLat) => {
    this.setState({lon: lonLat.lng, lat: lonLat.lat}) //{lon: lonLat.lng, lat: lonLat.lat}
  }
  handleAddToList = () =>{
    const cityValidation = nameSchema.validate(this.state.city);
        const stateValidation = nameSchema.validate(this.state.state);
        const countryValidation = nameSchema.validate(this.state.country)
        let newStateError = {
            city : false,
            state : false,
            country : false,
            citiesList:false
          }
        if (cityValidation.error) {
            
            newStateError = {...newStateError, city: true}
        }
        if (stateValidation.error) {
            
            newStateError = {...newStateError, state: true}
        }
        if (countryValidation.error) {
            newStateError = {...newStateError, country: true}
        }
        this.setState({errors: newStateError})
        if(cityValidation.error || stateValidation.error || countryValidation.error) {return}
        const cities = [...this.state.citiesList]
        cities.push({
            city : this.state.city,
            state : this.state.state,
            country : this.state.country,
            fullName : `${this.state.city}, ${this.state.state}, ${this.state.country}`.toLowerCase(),
            cityEn : this.state.cityEn,
            stateEn : this.state.stateEn,
            countryEn : this.state.countryEn,
            fullNameEn : `${this.state.cityEn}, ${this.state.stateEn}, ${this.state.countryEn}`.toLowerCase(),
            priceTypeDefault : this.state.priceTypeDefault,
            lat : this.state.lat,
            lon : this.state.lon,
            airportCoord:{
              lat : this.state.lat,
              lon : this.state.lon,
            },
            radius : this.state.radius,
            emoji: this.state.emoji
        })
        this.setState({
            city : '',
            citiesList: cities
        })

  }
  handleDeleteCity =(index) =>{
    const cities = [...this.state.citiesList]
    cities.splice(index, 1)
    this.setState({citiesList: cities})
  }
  logEmoji (event, emojiObject) {
    this.setState({emoji: {
      emoji: emojiObject.emoji,
      url: `https://cdn.jsdelivr.net/npm/emoji-datasource-apple@6.0.1/img/apple/64/${emojiObject.unified}.png`
    }})
  }
  render() {
    return (
      <>
      <div className="content">
        <Row>
          <Col md="12">
          <Card>
          <CardHeader>
          <CardTitle tag="h4">Crear ciudad</CardTitle>
          </CardHeader>
      <CardBody>
        <form onSubmit={this.handleSubmit}>
        <Row className='m-0'>
            <Col className="pr-md-1" md="4">
                <FormGroup>
                    <Label for="city">ciudad</Label>
                    <Input
                        id="city"
                        name="city"
                        onChange={this.handleChange}
                        type='text'
                        value={this.state.city}
                        invalid={this.state.errors.city}
                        placeholder="ciudad"
                    />
                    <FormFeedback>El campo ciudad esta Vacio</FormFeedback>
                </FormGroup>
            </Col>
            <Col className="pr-md-1" md="4">
                <FormGroup>
                    <Label for="state">Estado</Label>
                    <Input
                        id="state"
                        name="state"
                        onChange={this.handleChange}
                        type='text'
                        value={this.state.state}
                        invalid={this.state.errors.state}
                        placeholder="Estado"
                    />
                    <FormFeedback>El campo estado esta Vacio</FormFeedback>
                </FormGroup>
            </Col>
            <Col className="pr-md-1" md="4">
                <FormGroup>
                    <Label for="country">Pais</Label>
                    <Input 
                    className='p-0'
                      value={this.state.country} 
                        name="country"
                        id="country"
                        invalid={this.state.errors.country}
                        onChange={this.handleChange}
                        type='text'>
                    {/*country.countries.map((c,i) => {
                        return <option key={`countries-${i}`} value={c.name}>{`${c.name}`}</option>
                    })*/}</Input>
                    <FormFeedback>El Campo Pais esta vacio</FormFeedback>
                </FormGroup>
            </Col>
            {/**lo mismo pero en ingles */}
            <Col className="pr-md-1" md="4">
                <FormGroup>
                    <Label for="cityEn">city</Label>
                    <Input
                        id="cityEn"
                        name="cityEn"
                        onChange={this.handleChange}
                        type='text'
                        value={this.state.cityEn}
                        invalid={this.state.errors.city}
                        placeholder="ciudad"
                    />
                    <FormFeedback>El campo ciudad esta Vacio</FormFeedback>
                </FormGroup>
            </Col>
            <Col className="pr-md-1" md="4">
                <FormGroup>
                    <Label for="stateEn">State</Label>
                    <Input
                        id="stateEn"
                        name="stateEn"
                        onChange={this.handleChange}
                        type='text'
                        value={this.state.stateEn}
                        invalid={this.state.errors.state}
                        placeholder="Estado"
                    />
                    <FormFeedback>El campo estado esta Vacio</FormFeedback>
                </FormGroup>
            </Col>
            <Col className="pr-md-1" md="4">
                <FormGroup>
                    <Label for="countryEn">Country</Label>
                    <Input 
                    className='p-0'
                      value={this.state.countryEn} 
                        name="countryEn"
                        id="countryEn"
                        invalid={this.state.errors.country}
                        onChange={this.handleChange}
                        type='text'>
                    {/*country.countries.map((c,i) => {
                        return <option key={`countries-${i}`} value={c.name}>{`${c.name}`}</option>
                    })*/}</Input>
                    <FormFeedback>El Campo Pais esta vacio</FormFeedback>
                </FormGroup>
            </Col>
        </Row>
        <Row className='m-0'>
            <Col className="pr-md-1" md="3">
                <FormGroup>
                    <Label for="lat">lat</Label>
                    <Input
                        id="lat"
                        name="lat"
                        onChange={this.handleChangeLngLat}
                        type='number'
                        value={this.state.lat}
                        invalid={this.state.errors.lat}
                        placeholder="ciudad"
                    />
                </FormGroup>
            </Col>
            <Col className="pr-md-1" md="3">
                <FormGroup>
                    <Label for="lon">lon</Label>
                    <Input
                        id="lon"
                        name="lon"
                        onChange={this.handleChangeLngLat}
                        type='number'
                        value={this.state.lon}
                        invalid={this.state.errors.lon}
                        placeholder="Estado"
                    />
                </FormGroup>
            </Col>
            <Col className="pr-md-1" md="3">
                <FormGroup>
                    <Label for="radius">radio en metros</Label>
                    <Input 
                    className='p-0'
                      value={this.state.radius} 
                        name="radius"
                        id="radius"
                        invalid={this.state.errors.radius}
                        onChange={this.handleChange}
                        type='text'>
                    {/*country.countries.map((c,i) => {
                        return <option key={`countries-${i}`} value={c.name}>{`${c.name}`}</option>
                    })*/}</Input>
                </FormGroup>
            </Col>
            <Col className="pr-md-1" md="3">
                <FormGroup>
                    <Label for="priceTypeDefault">Moneda default</Label>
                    <Input 
                    className='p-0'
                      value={this.state.priceTypeDefault} 
                        name="priceTypeDefault"
                        id="priceTypeDefault"
                        invalid={this.state.errors.priceTypeDefault}
                        onChange={this.handleChange}
                        type='text'>
                    {/*country.countries.map((c,i) => {
                        return <option key={`countries-${i}`} value={c.name}>{`${c.name}`}</option>
                    })*/}</Input>
                </FormGroup>
            </Col>
            <Col className="pr-md-1" md="6">
                <FormGroup>
                    <Label for="latAirport">lat del aeropuerto</Label>
                    <Input
                        id="latAirport"
                        name="latAirport"
                        onChange={this.handleChangeLngLat}
                        type='number'
                        value={this.state.latAirport}
                        invalid={this.state.errors.latAirport}
                        placeholder="ciudad"
                    />
                </FormGroup>
            </Col>
            <Col className="pr-md-1" md="6">
                <FormGroup>
                    <Label for="lonAirport">lon del aeropuerto</Label>
                    <Input
                        id="lonAirport"
                        name="lonAirport"
                        onChange={this.handleChangeLngLat}
                        type='number'
                        value={this.state.lonAirport}
                        invalid={this.state.errors.lonAirport}
                        placeholder="Estado"
                    />
                </FormGroup>
            </Col>
            <Col className="pr-md-1" md="6">
                <FormGroup>
                    <Label for="priority">Prioridad</Label>
                    <Input
                        id="priority"
                        name="priority"
                        onChange={this.handleChangeLngLat}
                        type='number'
                        value={this.state.priority}
                        invalid={this.state.errors.priority}
                        placeholder="Estado"
                    />
                </FormGroup>
            </Col>
        </Row>

        <FormGroup>
                    <Label for="icon">Icon</Label>
                    <div className='iconPickerCont d-flex justify-content-around'>
                    <Picker 
                    onEmojiClick={this.logEmoji.bind(this)}
                    disableSkinTonePicker={true}
                    groupVisibility={false}
                    disableAutoFocus={true}
                    groupNames={{ smileys_people: "PEOPLE" }} />
                    <span>{this.state.emoji && <img alt={this.state.emoji.emoji} 
                    src={this.state.emoji.url}></img>}</span>
                    </div>
                </FormGroup>
          
          <Button onClick={this.handleAddToList} color="primary" type="button">
            Añadir ciudad a la lista
          </Button>
          {(this.state.citiesList.length >0) && <Row>
                <ul > 
                    {this.state.citiesList.map((e,i) => {
                        
                        return (
                          <li className='d-flex justify-content-around'>
                          
                          <img style={{height: '30px'}} alt={e.emoji.emoji} src={e.emoji.url}></img>
                          <p className='mb-0 mt-1 mr-2'>{`${e.city}`}<span>, {`${e.state}, ${e.country}`}</span></p>
                          <button style={{
                            fontSize: '10px',
                            border: 'none',
                            borderRadius: '5px',
                            color:'white',
                            backgroundColor: 'rgb(51, 88, 244)'

                        }} onClick={() => {this.handleDeleteCity(i)}} type='button'>Eliminar</button> </li>
                        
                    )})}
                </ul>
          </Row>}
          <Button disabled={(this.state.citiesList.length ===0)} color="primary" type="submit">
            Enviar Ciudades
          </Button>
        </form>
      </CardBody>
    </Card>
          </Col>
            
        </Row>
        <Row>
          <Col md="12">
          <Card>
              <CardHeader>
              <CardTitle tag="h4">o introduce un excel para editar las ciudades existentes
              </CardTitle>
              </CardHeader>
            <CardBody>
              <Col className="pl-md-1" md="12">
                <Label >Introduzca el archivo Xlsx</Label>
                <Dropzone onDrop={this.handleFile}>
                  {({getRootProps, getInputProps}) => (
                    <section>
                      <div  className='dropZoneCont' {...getRootProps()}>
                        <input accept='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' {...getInputProps()} />
                        <p>{!this.state.file.name ? "Drag 'n' drop some files here, or click to select files" : this.state.file.name}</p>
                      </div>
                    </section>
                  )}
                </Dropzone>
              </Col>
              <Button disabled={this.state.disabled} onClick={this.handleExcelCities} color="primary" type="button">
              Añadir ciudad a la lista
            </Button>
            </CardBody>
          </Card>
          </Col>
            
        </Row>
      </div>
    </>
    )
  }
}


export default withRouter(FormCities);
